<template>
  <small class="help-block">
    <font-awesome-icon :icon="'exclamation-triangle'" />
    {{ message }}
  </small>
</template>

<script>
export default {
  name: 'input-error-message',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/InputErrorMessage.vue